export class SponsorshipError extends Error {
    constructor(message: string, statusCode?: number) {
        super(`${message} with status code ${statusCode}`);
        this.name = "USCSponsorshipError";
        this.stack = "";
    }
}
